import { i18n } from '@fs/zion-locale'

export default {
  correctMetadata: () => i18n.t('view-manager.correct-metadata', 'Correct Metadata'),
  divideImageGroup: () => i18n.t('view-manager.divide-image-group', 'Divide Image Group'),
  doNotHavePermission: () =>
    i18n.t('infoSheetWrapper.unauthorizedImageOrganizeMessage', 'You do not have permission to edit this image group.'),
  editImageGroup: () => i18n.t('view-manager.edit-mode-single-item', 'Edit Image Group'),
  editItem: (itemNumber) => i18n.t('view-manager.edit-mode', 'Edit Item {itemNumber}', { itemNumber }),
  information: () => i18n.t('headerNavigation.information', 'Information'),
  unauthorizedAudit: () =>
    i18n.t('infoSheetWrapper.unauthorizedImageAudit', 'You do not have permission to audit this image group.'),
}
